export const styleMap = ['flat', 'floating', 'neo', 'tint']

export const colorMap = ['blue', 'indigo', 'cyan','jade','green','grass','orange','tomato', 'red','crimson','pink','purple','violet','plum','teal','brown','gold','bronze','gray']

export const modeMap = ['light', 'dark']